/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Sync200ResponseOneOf1VirtualBrandsClosingTimesInner
 */
export interface Sync200ResponseOneOf1VirtualBrandsClosingTimesInner {
    /**
     * 
     * @type {string}
     * @memberof Sync200ResponseOneOf1VirtualBrandsClosingTimesInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Sync200ResponseOneOf1VirtualBrandsClosingTimesInner
     */
    brandName: string;
    /**
     * 
     * @type {{ [key: string]: string | null; }}
     * @memberof Sync200ResponseOneOf1VirtualBrandsClosingTimesInner
     */
    externalDeliveryCompaniesClosingTimes: { [key: string]: string | null; };
}

/**
 * Check if a given object implements the Sync200ResponseOneOf1VirtualBrandsClosingTimesInner interface.
 */
export function instanceOfSync200ResponseOneOf1VirtualBrandsClosingTimesInner(value: object): value is Sync200ResponseOneOf1VirtualBrandsClosingTimesInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('brandName' in value) || value['brandName'] === undefined) return false;
    if (!('externalDeliveryCompaniesClosingTimes' in value) || value['externalDeliveryCompaniesClosingTimes'] === undefined) return false;
    return true;
}

export function Sync200ResponseOneOf1VirtualBrandsClosingTimesInnerFromJSON(json: any): Sync200ResponseOneOf1VirtualBrandsClosingTimesInner {
    return Sync200ResponseOneOf1VirtualBrandsClosingTimesInnerFromJSONTyped(json, false);
}

export function Sync200ResponseOneOf1VirtualBrandsClosingTimesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): Sync200ResponseOneOf1VirtualBrandsClosingTimesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'brandName': json['brandName'],
        'externalDeliveryCompaniesClosingTimes': json['externalDeliveryCompaniesClosingTimes'],
    };
}

export function Sync200ResponseOneOf1VirtualBrandsClosingTimesInnerToJSON(json: any): Sync200ResponseOneOf1VirtualBrandsClosingTimesInner {
    return Sync200ResponseOneOf1VirtualBrandsClosingTimesInnerToJSONTyped(json, false);
}

export function Sync200ResponseOneOf1VirtualBrandsClosingTimesInnerToJSONTyped(value?: Sync200ResponseOneOf1VirtualBrandsClosingTimesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'brandName': value['brandName'],
        'externalDeliveryCompaniesClosingTimes': value['externalDeliveryCompaniesClosingTimes'],
    };
}

